import { render, staticRenderFns } from "./notice-event-list.vue?vue&type=template&id=7bf65aea&scoped=true&"
import script from "./notice-event-list.vue?vue&type=script&lang=js&"
export * from "./notice-event-list.vue?vue&type=script&lang=js&"
import style0 from "./notice-event-list.vue?vue&type=style&index=0&id=7bf65aea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf65aea",
  null
  
)

export default component.exports